import {
  START_BUYERS_SEARCH,
  RECEIVE_BUYERS_SEARCH_RESULTS,
  BUYERS_SEARCH_FAILED
} from '../actions/types';

export const buyersSearchRequest = (state = {}, action) => {
  switch (action.type) {
    case START_BUYERS_SEARCH:
      return Object.assign({}, state, {
        isFetching: true,
        results: state.results || {},
        error: null
      });
    case RECEIVE_BUYERS_SEARCH_RESULTS:
      return Object.assign({}, state, {
        isFetching: false,
        results: Object.assign({}, state.results, { [action.query]: action.results }),
        error: null
      });
    case BUYERS_SEARCH_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        results: state.results || {},
        error: action.error
      });
    default:
      return state;
  }
};
